import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { ArrowLeft, Plus, Upload } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Dashboard from "../dashboard/dashboard";
import { CheckRegisterList } from "../list/list";

const CheckRegisterLanding = () => {
  const navigate = useNavigate();
  return (
    <div className="p-2">
      <div className="flex justify-between items-start mb-6">
        <div className="flex items-center gap-4">
          <ArrowLeft
            className="w-5 h-5 cursor-pointer text-gray-700"
            onClick={() => navigate("/cx/payments")}
          />
          <div className="flex flex-col">
            <PageHeader
              title={"Check Register"}
              subtitle="Record check payments at the counter or from field-agent lots, track clearance and dishonour. Provisional credit is applied on entry; on dishonour the credit is auto-reversed and a penalty is posted. A disconnect hold protects the consumer during the clearing period."
            />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            onClick={() => navigate("/cx/payments/bulk-payment/create")}
          >
            <Upload className="h-4 w-4 mr-2" />
            Create Bulk Payment
          </Button>
          <Button
            variant="default"
            onClick={() => navigate("/cx/payments/create")}
          >
            <Plus className="h-4 w-4 mr-2" />
            Record Check
          </Button>
        </div>
      </div>

      <Dashboard />
      <CheckRegisterList />
    </div>
  );
};

export default CheckRegisterLanding;
